export const NAVY = "#081627";
export const CREAM = "#F7F3EC";
export const ACCENT = "#E8A33D";
export const INK = "#11212F";
export const NAVY_PANEL = "#123a5e";
